import axios from '@/api/axios'
import { result } from 'lodash'
// import _ from 'lodash'

const apiUrlEx = '/a1/car'

const list = async (curPage, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }
  const options = {
    method: 'GET',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      page: curPage
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })

}

const del = async (seq, result) => {
  const options = {
    method: 'DELETE',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: {
      seq: seq
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 400) {
        result(response.data.message)
      } else {
        result(null)
      }
    })
}

const get = async (seq, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/' + seq,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }
  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })
}

const save = async (seq, form, result) => {
  const options = {
    method: 'PUT',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: form
  }
  if (seq) {
    options.method = 'PUT'
    await axios(options)
      .then((response) => {
        if (response.data.code === 300) {
          result(response.data.code, response.data.message)
        } else {
          result(null)
        }
      })
  } else {
    options.method = 'POST'
    await axios(options)
      .then((response) => {
        if (response.data.code === 200) {
          result(response.data.code, response.data.message)
        } else {
          result(null)
        }
      })
  }
}

const carNumberByCompany = async (csseq, result) => {
  const options = {
    method: 'GET',
    url: apiUrlEx + '/car-num-by-company',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    params: {
      csseq: csseq
    }
  }
  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        result(response.data.data)
      } else {
        result(null)
      }
    })
}

const vdbList = async (result) => {
  let finalData = {
    item : {},
  }

  const options = {
    method: 'GET',
    url: apiUrlEx + '/vehicle-dashboard-list',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }

  await axios(options).then((response) => {
      if (response.data.code === 100) {
        finalData.item = response.data.data
        result(finalData)
      } else {
        console.error(response.data.code, response.data.message)
        result(null)
      }
  })
}

const vdbLastData = async(id, result) => {
  let finalData = {
    item : {}
  }

  const options = {
    method: 'GET',
    url: apiUrlEx + '/vehicle-dashboard-lastdata',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    params: {
      id: id
    }
  }

  await axios(options).then((response) => {
    if (response.data.code === 100) {
      finalData.item = response.data.data
      result(finalData)
    } else {
      console.error(response.data.code, response.data.message)
      result(null)
    }
  })
} 

export default {
  list,
  del,
  get,
  save,
  carNumberByCompany,
  vdbList,
  vdbLastData
}

export {
  carNumberByCompany
}
